import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, CheckboxComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-immutability-disable-modal',
  templateUrl: './immutability-disable-modal.component.html',
  imports: [CommonModule, ButtonComponent, FormsModule, I18NextPipe, ModalComponent, CheckboxComponent, ModalFooterDirective]
})
export class ImmutabilityDisableModalComponent {
  public readonly mbsPopupType = MbsPopupType;
  public confirmed = false;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  confirmClickHandler(): void {
    this.baseModal.save({ confirm: true });
  }

  cancelClickHandler(): void {
    this.baseModal.close();
  }
}
